import React from 'react';

import Alert from 'common/components/Alert';
import { ButtonLink } from 'common/components/Button';
import { MessageType } from 'common/enums/Alert';
import { useLocalization } from 'common/providers/LocaleProvider';
import HelpSectionLinks from './common/HelpSectionLinks';

interface CtaSliceProps {
  reason: string;
}

export const CtaSlice = ({ reason }: CtaSliceProps) => {
  const { t, p } = useLocalization();

  return (
    <>
      <HelpSectionLinks reason={reason} />
      <Alert mb={['sp_16', 'sp_20']} type={MessageType.Notice}>
        {t(`h24_contact_form_${reason}_info_text`)}
      </Alert>
      <ButtonLink href={p.t(`h24_contact_form_${reason}_cta_url`)}>
        {t(`h24_contact_form_${reason}_cta_label`)}
      </ButtonLink>
    </>
  );
};
